// Generated from reviewed coded integration packages. Run scripts/generate-connect-views.mjs.
import {Type} from '@angular/core';
import {CredentialCanaryComponent} from './credential-canary.component';
import {OpsHealthAuditComponent} from './ops-health-audit.component';

export const CODED_INTEGRATION_VIEWS: Readonly<Record<string, Type<{installationId: string}>>> = Object.freeze({
    'credential-canary': CredentialCanaryComponent,
    'ops-health-audit': OpsHealthAuditComponent,
});
